// monetization status
export const MONETIZATION_DISABLED = 0
export const MONETIZATION_ENABLED = 1
// Bitwise value 2 for game means token marketplace is enabled, for a mod it means mod marketplace is enabled overall
// Two variables have been defined to avoid confusion
export const MONETIZATION_MARKETPLACE_ENABLED_MOD = 2
export const MONETIZATION_MARKETPLACE_TOKEN = 2
export const MONETIZATION_SCARCITY = 8
export const MONETIZATION_WEB_DISABLE_SELF_REFUNDS = 1024
export const MONETIZATION_MARKETPLACE_USD = 2048
export const MONETIZATION_PARTNER_PROGRAM_PREVIEW = 4096

// paid mods status
export const MOD_FREE = 0
export const MOD_PAID = 1
export const MOD_FREE_AND_PAID = 2
export const MOD_FREE_AND_PAID_WEIGHTED = 3

// tilia
export const TILIA_STATE_CANCEL = 'cancel'
export const TILIA_STATE_ERROR = 'error'
export const TILIA_TYPE_PAYMENT = 'payment-selection'

// checkout state
export const VIRTUAL_TOKEN = 0
export const SKU_PACK = 1

export const CHECKOUT_UNIFIED = 2
// 2-step checkout for USD marketplace
export const CHECKOUT_UNIFIED_INTENT = 3
export const CHECKOUT_UNIFIED_COMMIT = 4

// onboarding status
export const TILIA_STATUS_UNREGISTERED = 0
export const TILIA_STATUS_PENDING = 1
export const TILIA_STATUS_REJECTED = 2
export const TILIA_STATUS_REVIEW = 4
export const TILIA_STATUS_ACTION = 8
export const TILIA_STATUS_APPROVED = 16
export const TILIA_STATUS_MEMBER = 32

// wallet type
export const WALLET_CONVERTIBLE = 'convertible'
export const WALLET_CONVERTIBLE_HOLDING = 'convertible_holding'
export const WALLET_DEFAULT_HOLDING = 'default_holding'
export const WALLET_DEFAULT_USD = 'default_usd'
export const WALLET_STANDARD_MIO = 'standard_mio'

// monetization authentication token types
export const AUTH_SCOPE_ACCOUNT = 'me'
export const AUTH_SCOPE_GAME = 'game'
export const AUTH_SCOPE_MOD = 'mod'

// Partner Program application status
export const PARTNER_PROGRAM_APPLICATION_PENDING = 0
export const PARTNER_PROGRAM_APPLICATION_SUCCESS = 1
export const PARTNER_PROGRAM_APPLICATION_REJECTED = 2

export const MARKETPLACE_QUEUE_STATUS_PENDING = 0
export const MARKETPLACE_QUEUE_STATUS_SUCCESS = 1
export const MARKETPLACE_QUEUE_STATUS_REJECTED = 2
